import { render, staticRenderFns } from "./KnowledgeBaseExplorer.vue?vue&type=template&id=cd737bcc&scoped=true&lang=pug&"
import script from "./KnowledgeBaseExplorer.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseExplorer.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseExplorer.vue?vue&type=style&index=0&id=cd737bcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd737bcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
